module.exports = __webpack_public_path__ + "static/media/token-cake.e06b0ba9.svg";